import React from "react";
import BasicMenu from "./menu";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";
import { ArrowDropDown, ArrowRight, Menu, People, Settings } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

const Structure = ({
  structures,
  setValue0,
  setParent,
  setOpen,
  handleDelete,
  setSelectedStructure,
  setOpenAddMenu,
  loggedUser,
  setSelectedType,
  setOpenSetting,
  wholeStructure
}) => {
  const [openChildren, setOpenChildren] = React.useState(false);
  const [id, setId] = React.useState(false);

  const isSuperAdmin = loggedUser?.role === "superAdmin";
  const isAdmin = isSuperAdmin || loggedUser?.role === "admin";
  let history = useHistory();

  return (
    <List sx={{ pl: 4 }}>
      {(wholeStructure?.length ? wholeStructure : structures )?.map((structure) => {
        const children = structure?.children;
        const openStructure = openChildren && id === structure?.id;
        return (
          <>
            <ListItemButton
              onClick={() => {
                setOpenChildren(!openChildren);
                setId(structure?.id);
                setSelectedStructure(structure);
              }}
              selected={id === structure?.id}
            >
              <ListItemIcon>
                {openStructure ? <ArrowDropDown /> : <ArrowRight />}
              </ListItemIcon>
              <ListItemText primary={structure?.name} />

              {isAdmin ? (
                <>
                  <Typography sx={{ mr: 4 }}>{structure?.category}</Typography>

                  <BasicMenu
                    // onDelete={ structure?.parentId === null && isSuperAdmin?() => handleDelete(structure?.id):null}
                    onEdit={() => {
                      setOpen(2);
                      setId(structure?.id);
                      setValue0("name", structure?.name);
                      setValue0("code", structure?.code);
                      setValue0("category", structure?.category);
                      setValue0("id", structure?.id);
                      setParent(structure?.parent);

                    }}
                    onAdd={() => {
                      setParent(structure);
                      setOpen(1);
                    }}
                    extra={
                      structure?.parentId === null && isSuperAdmin
                        ? [
                            {
                              label: "Assign Menu",
                              icon: <Menu />,
                              onClick: () => {
                                setOpenAddMenu(true);
                                setSelectedStructure(structure);
                                setSelectedType("menu");
                              },
                            },
                            {
                              label: "Assign Actions",
                              icon: <MenuItem />,
                              onClick: () => {
                                setOpenAddMenu(true);
                                setSelectedStructure(structure);
                                setSelectedType("action");
                              },
                            },
                            {
                              label: "Users",
                              icon: <People />,
                              onClick: () => {
                                history.push(`/admin/system/users`,{structure,url:`/api/structure/user/admin/dataTable/${structure?.id}`}); 
                              },
                            },
                            {
                              label: "Settings",
                              icon: <Settings />,
                              onClick: () => {
                                setOpenSetting(1)
                                setSelectedStructure(structure);

                              },
                            },
                          ]
                        : null
                    }
                    addName="Add New"
                  />
                </>
              ) : null}
            </ListItemButton>
            <Collapse in={openStructure} timeout="auto" unmountOnExit>
              {children?.length > 0 && (
                <Structure
                  structures={children}
                  wholeStructure={children}
                  setValue0={setValue0}
                  setParent={setParent}
                  setOpen={setOpen}
                  handleDelete={handleDelete}
                  setSelectedStructure={setSelectedStructure}
                  setOpenAddMenu={setOpenAddMenu}
                  loggedUser={loggedUser}
                  setSelectedType={setSelectedType}
                  setOpenSetting={setOpenSetting}
                />
              )}
            </Collapse>
          </>
        );
      })}
    </List>
  );
};

const StructureHierachy = ({
  structures,
  setValue0,
  setParent,
  setOpen,
  handleDelete,
  setSelectedStructure,
  setOpenAddMenu,
  loggedUser,
  setSelectedType,
  setOpenSetting,
  wholeStructure
}) => {
  return (
    <Structure
      structures={structures}
      setValue0={setValue0}
      setParent={setParent}
      setOpen={setOpen}
      handleDelete={handleDelete}
      setSelectedStructure={setSelectedStructure}
      setOpenAddMenu={setOpenAddMenu}
      loggedUser={loggedUser}
      setSelectedType={setSelectedType}
      setOpenSetting={setOpenSetting}
      wholeStructure={wholeStructure}
    />
  );
};

export default StructureHierachy;
